import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/reactApi/api';


class CommonAPIService {
  
  static async terminateApplication(appId, orgId, reason, files = null) {
    try {
      const response = await axios.post(`${API_URL}/common/terminate-application`, {
        appId,
        orgId,
        reason,
        files,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  static async verifyPassword(orgId, password) {
    try {
      const response = await axios.post(`${API_URL}/auth/verify-password`, {
        orgId,
        password
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
  static async getAssessmentSendToNABLDate(appId) {
    try {
      const response = await axios.get(`${API_URL}/common/get-assessment-send-to-nabl-date/${appId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

  static async getAssessorBankDetails(assessorId) {
    try {
      const response = await axios.get(`${API_URL}/common/assessor-bank-detail/${assessorId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }

static async saveCheckPointsCalibrationWitness(data) {
  try {
    const response = await axios.post( `${API_URL}/common/save-check-points-calibration`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
 }

 static async deleteWitnessFile(data) {
  try {
    const response = await axios.post(
      `${API_URL}/common/delete-witness-file`,
      data
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
 }
}

export default CommonAPIService;
